import { Route } from 'react-router-dom';
import { JoinAndAllocationPersonalInformation } from '@dealstack/frontend/investor/pages/Investment/InvestmentJoinAndAllocation/JoinAndAllocationPersonalDetails/JoinAndAllocationPersonalInformation/JoinAndAllocationPersonalInformation';
import { JoinAndAllocationPIVInformation } from '@dealstack/frontend/investor/pages/Investment/InvestmentJoinAndAllocation/JoinAndAllocationPersonalDetails/JoinAndAllocationPIVInformation/JoinAndAllocationPIVInformation';
import { JoinAndAllocationBankAccount } from '@dealstack/frontend/investor/pages/Investment/InvestmentJoinAndAllocation/JoinAndAllocationPersonalDetails/JoinAndAllocationBankAccount/JoinAndAllocationBankAccount';
import { JoinAndAllocationOtherDetails } from '@dealstack/frontend/investor/pages/Investment/InvestmentJoinAndAllocation/JoinAndAllocationPersonalDetails/JoinAndAllocationOtherDetails/JoinAndAllocationOtherDetails';
import { SentryRoutes } from '@dealstack/frontend/shared/sentry';

export enum JOINER_ALLOCATION_PERSONAL_DETAILS_ROUTES {
	PERSONAL_INFORMATION = '/personal-information',
	INVESTMENT_VEHICLE_INFORMATION = '/investment-vehicle-information',
	BANK_ACCOUNT = '/bank-account',
	OTHER_DETAILS = '/other-details',
}

export const JoinAndAllocationPersonalDetails = () => {
	return (
		<div style={{ maxWidth: '40rem' }}>
			<SentryRoutes>
				<Route
					path={JOINER_ALLOCATION_PERSONAL_DETAILS_ROUTES.PERSONAL_INFORMATION}
					element={<JoinAndAllocationPersonalInformation />}
				/>
				<Route
					path={JOINER_ALLOCATION_PERSONAL_DETAILS_ROUTES.INVESTMENT_VEHICLE_INFORMATION}
					element={<JoinAndAllocationPIVInformation />}
				/>
				<Route
					path={JOINER_ALLOCATION_PERSONAL_DETAILS_ROUTES.BANK_ACCOUNT}
					element={<JoinAndAllocationBankAccount />}
				/>
				<Route
					path={JOINER_ALLOCATION_PERSONAL_DETAILS_ROUTES.OTHER_DETAILS}
					element={<JoinAndAllocationOtherDetails />}
				/>
			</SentryRoutes>
		</div>
	);
};
